export const DRAWER_WIDTH = 264;

export const APPBAR_HEIGHT = { xs: 60, sm: 68 };
